console.log('main v7.8');

import jQuery from 'jquery';
import 'cssuseragent';
import 'jquery.easing';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
const $ = jQuery;

import Router from './module/Router';
import Swiper, { Pagination, Autoplay } from 'swiper';

window.jQuery = $;
window.$ = $;

Swiper.use([Pagination, Autoplay]);

let trs = 400;

//＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

class MainApp {
  constructor() {
    this.$window = $(window);
    this.scrollEffect = new ScrollEffect();
    this.router = new Router(this);

    this.$window
      .on('resize', () => {
        this.onWindowResize();
      })
      .on('scroll', () => {
        this.onWindowScroll();
      });
    this.onWindowResize();
  }

  // ページ遷移の度に呼ばれる関数
  initializePage() {
    // 50ms遅らせてからinitを初期化する
    // barba.jsのイベント発火はそれなりに正確なタイミングで実行されるはずだが、何故か前のページの要素がまだ残っている状態でinitされてしまっていた
    // 大抵のページでは、最低50ms待てばDOMの状態は完全に新しいページの物になっているので、そのタイミングで初期化を実行する
    setTimeout(() => {
      this.scrollEffect.init();
      new SmoothScroll(); // ここでSmoothScrollを初期化
    }, 100);
  }

  onWindowResize() {
    this.windowWidth = this.$window.width();
    this.windowHeight = this.$window.height();
    this.onWindowScroll();
  }

  onWindowScroll() {
    this.scrollTop = this.$window.scrollTop();
  }
}
//＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

class MenuApp {
  constructor() {
    this.trs = trs;
    this.setupEventListeners();
  }

  setupEventListeners() {
    $(document).on(
      'click',
      '.Button__Menu.--Close, .Button__Menu.--Loaded',
      () => {
        this.OpenMenu();
      }
    );

    $(document).on('click', '.Button__Menu.--Open', () => {
      this.CloseMenu();
    });
  }

  OpenMenu() {
    $('.MenuBg, .Button__Menu').addClass('--Open');
    $('.Button__Menu').removeClass('--Close --Loaded');

    setTimeout(() => {
      $('.Menu, .Header__Logo').addClass('--Open');
    }, this.trs + 500);
  }

  CloseMenu() {
    $('.MenuBg, .Menu, .Header__Logo, .Button__Menu').removeClass(
      '--Open --Loaded'
    );
    setTimeout(function () {
      $('.MenuBg').addClass('--Loaded');
    }, 2000);
    $('.Button__Menu').addClass('--Close');
  }
}

//＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

//スクロール演出を管理するクラス;
class ScrollEffect {
  constructor() {}

  destroy() {
    // 基本的にはこれだけで全てのトリガーが削除される
    ScrollTrigger.killAll();

    // マーカーは手動で削除するしか無い。
    // 開発時にしか使わない物なのに、SPAのページ遷移時にマーカーを削除する機能を追加してまで、ライブラリの容量を増やすべきでは無い、という判断がされてる(2020年時点)
    // https://greensock.com/forums/topic/24516-scrolltrigger-markers-are-not-removed-when-killed/
    $(
      '.gsap-marker-start, .gsap-marker-end, .gsap-marker-scroller-start, .gsap-marker-scroller-end'
    ).remove();
  }

  init() {
    // querySelectorは動的に追加された要素の検出が出来ない場合があるので、要素の取得には基本的にjQueryを使う
    $('.ContentMoving').each((i, e) => {
      gsap.to($(e), {
        scrollTrigger: {
          trigger: $(e),
          markers: false,
          start: 'top 70%',
          end: 'bottom 60%',
          onEnter: () => {
            $(e).children('.Headline').addClass('fadeIn--glitch');
            $(e).children('.WhiteMaskScroll').addClass('--Leaving');
            setTimeout(() => {
              $(e).children('.OpacityScroll').addClass('--Leaving');
              $(e).children('.OpacityScrollNews').addClass('--Leaving');
            }, 1000);
            setTimeout(() => {
              $(e).children('.WhiteMaskScroll').addClass('--Done');
            }, 3000);
          },
        },
      });
    });
    gsap.to('.Header__Left.--HomePosition', {
      scrollTrigger: {
        trigger: '.Show__HomeLogo',
        start: 'top 0%',
        end: 'bottom 60%',
        onEnter: () => $('.Header__Left.--HomePosition').addClass('--Done'),
        onLeaveBack: () =>
          $('.Header__Left.--HomePosition').removeClass('--Done'),
      },
    });
  }
}
//＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

class MainVisual {
  constructor() {
    this.trs = trs;
  }
  slideShow() {
    setTimeout(function () {
      var v = document.getElementById('mainVisual__video');
      v.play();
    }, 6000);
  }
}

//＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

class SmoothScroll {
  constructor() {
    this.links = document.querySelectorAll('.scroll-link');
    this.addEventListeners();
  }

  addEventListeners() {
    this.links.forEach((link) => {
      link.addEventListener('click', this.scrollTo.bind(this));
    });
  }

  scrollTo(event) {
    event.preventDefault();
    const targetId = event.currentTarget.getAttribute('href');
    const targetElement = document.querySelector(targetId);

    if (targetElement) {
      const targetPosition =
        targetElement.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth',
      });
    }
  }
}

//＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

window.menuApp = new MenuApp();
window.mainVisual = new MainVisual();
window.smoothScroll = new SmoothScroll();
const mainVisual = window.mainVisual;

$(document).ready(() => {
  new MainApp();

  // 左右の矢印のtransitionを統一
  $('.WhiteMaskScroll__arrow').css({
    transition: 'opacity 0.3s ease, visibility 0.3s ease',
  });

  // ニューススクロール
  var scrollIncrement = 70; // スクロール量を vw 単位で指定

  // 右スクロール - イベント委譲を使用
  $(document).on('click', '.WhiteMaskScroll__arrow--right', function (e) {
    e.preventDefault(); // デフォルトの動作を防止

    var $scrollContainer = $(this)
      .siblings('.WhiteMaskScroll')
      .find('.HomeNewsListsWrap');
    var currentScroll = $scrollContainer.scrollLeft();
    var scrollAmount = $(window).width() * (scrollIncrement / 100); // 画面幅の70%を計算
    $scrollContainer.animate({ scrollLeft: currentScroll + scrollAmount }, 800); // 800ミリ秒かけてスクロール

    // スクロール後に左矢印を表示
    $(this).siblings('.WhiteMaskScroll__arrow--left').addClass('--Leaving');

    // スクロール位置チェック
    checkScrollPosition(
      $scrollContainer,
      $(this),
      $(this).siblings('.WhiteMaskScroll__arrow--left')
    );
  });

  // 左スクロール - イベント委譲を使用
  $(document).on('click', '.WhiteMaskScroll__arrow--left', function (e) {
    e.preventDefault(); // デフォルトの動作を防止

    var $scrollContainer = $(this)
      .siblings('.WhiteMaskScroll')
      .find('.HomeNewsListsWrap');
    var currentScroll = $scrollContainer.scrollLeft();
    var scrollAmount = $(window).width() * (scrollIncrement / 100); // 画面幅の70%を計算
    $scrollContainer.animate({ scrollLeft: currentScroll - scrollAmount }, 800); // 800ミリ秒かけてスクロール

    // スクロール後にスクロール位置をチェック
    checkScrollPosition(
      $scrollContainer,
      $(this).siblings('.WhiteMaskScroll__arrow--right'),
      $(this)
    );
  });

  // スクロール位置をチェックする関数
  function checkScrollPosition($container, $rightArrow, $leftArrow) {
    setTimeout(function () {
      var currentScroll = $container.scrollLeft();
      var maxScroll = $container[0].scrollWidth - $container.width();

      // 左端に到達したら左矢印を非表示
      if (currentScroll <= 0) {
        $leftArrow.removeClass('--Leaving');
      } else {
        $leftArrow.addClass('--Leaving');
      }

      // 右端に到達したら右矢印を非表示（余裕を持たせる）
      if (maxScroll - currentScroll <= 400) {
        // 閾値を400pxに増やす
        $rightArrow.removeClass('--Leaving');
      } else {
        $rightArrow.addClass('--Leaving');
      }
    }, 850); // アニメーション完了後に実行
  }

  // 各ニュースコンテナのスクロール位置を初期化
  $('.HomeNewsListsWrap').each(function () {
    var $container = $(this);
    var $rightArrow = $container
      .closest('.WhiteMaskScroll')
      .siblings('.WhiteMaskScroll__arrow--right');
    var $leftArrow = $container
      .closest('.WhiteMaskScroll')
      .siblings('.WhiteMaskScroll__arrow--left');

    // 初期状態では左矢印を強制的に非表示に
    $leftArrow.removeClass('--Leaving');

    // スクロール可能かチェック
    if ($container[0].scrollWidth > $container.width()) {
      $rightArrow.addClass('--Leaving'); // 右矢印を表示
    }

    // スクロールイベントを監視
    $container.on('scroll', function () {
      // スクロール位置が0より大きい場合のみ左矢印を表示
      if ($container.scrollLeft() > 0) {
        $leftArrow.addClass('--Leaving');
      } else {
        $leftArrow.removeClass('--Leaving');
      }

      checkScrollPosition($container, $rightArrow, $leftArrow);
    });
  });

  $(document).on('click', '.Accordion--Head', function () {
    $(this).toggleClass('--Open');
    $(this).next().toggleClass('--Open');
    $(this).parent().toggleClass('--Open');
  });

  $(document).on('mouseenter', '.ProjectLists__Button', function () {
    $(this).next().addClass('--hover');
  });
  $(document).on('mouseleave', '.ProjectLists__Button', function () {
    $(this).next().removeClass('--hover');
  });
});

$(window).on('load', function () {
  mainVisual.slideShow();
  $('.PageTitle').addClass('fadeIn--glitch');
  setTimeout(function () {
    $('.WhiteMask').addClass('--Leaving');
    $('.MenuBg').addClass('--Loaded');
  }, 1000); // 1秒後に実行
});
